import { baseUrl } from 'Api';

// Turns text into spoken audio by calling our BE's OpenAI TTS proxy.
// Returns an object-URL pointing to an MP3 blob that an <audio> element
// can play (or null on empty input). Caller is responsible for revoking
// the URL when done via URL.revokeObjectURL().
//
// We used to hit `api.openai.com/v1/audio/speech` directly from the
// browser, which leaked the API key and ran into CORS. Now we POST to
// `${baseUrl}/ai/tts` and the BE forwards to OpenAI with the key.

const ENDPOINT_PATH = '/ai/tts';
const DEFAULT_VOICE = 'alloy';

export async function fetchSpeechBlobUrl(text, options = {}) {
  const trimmed = (text || '').trim();
  if (!trimmed) return null;

  const { signal, voice = DEFAULT_VOICE } = options;

  const res = await fetch(`${baseUrl}${ENDPOINT_PATH}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text: trimmed, voice }),
    signal,
  });

  if (!res.ok) {
    let detail = '';
    try {
      const data = await res.json();
      detail = (data && data.error) || '';
    } catch (e) {
      try { detail = (await res.text()).slice(0, 300); } catch (e2) { /* noop */ }
    }
    throw new Error(`TTS ${res.status}: ${detail || res.statusText}`);
  }

  const blob = await res.blob();
  return URL.createObjectURL(blob);
}
